module.exports = __webpack_public_path__ + "static/media/ro.dd4c1cfe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/ro.svg
// module id = 1465
// module chunks = 0